import * as React from "react";
import classnames from "classnames";
import Card from "../../Card/Card/Card.js";
/* empty css                 */
const RadioButton = ({
  name,
  variant = "outline",
  // TODO: change to "plain" when all occurrences are fixed and we want to do a BREAKING release
  children,
  className,
  disabled = false,
  isChecked,
  onChange,
  position = "left",
  value,
  id,
  "data-t": dataT,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  "label",
  {
    htmlFor: id || value,
    className: classnames(
      "radio-button",
      `radio-button--${variant}`,
      `radio-button--${position}`,
      className
    ),
    "data-t": dataT,
    ...rest
  },
  /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "radio",
      name: name || "radio-button",
      id: id || value,
      "aria-checked": isChecked,
      checked: isChecked,
      disabled,
      onChange,
      value,
      className: "radio-button__input"
    }
  ),
  variant === "outline" ? /* @__PURE__ */ React.createElement(Card.OldCard, { className: "radio-button__label" }, children) : /* @__PURE__ */ React.createElement("div", { className: "radio-button__label" }, children),
  /* @__PURE__ */ React.createElement("div", { className: "radio-button__radio-indicator" })
);
export {
  RadioButton as default
};
//# sourceMappingURL=RadioButton.js.map
